(function () {
  "use strict";

  const A11Y_OPTIONS = {
    textSize: true,
    contrast: true,
    grayscale: true,
    links: true,
    focus: false,
    animations: true,
    cursor: true,
    readableFont: true,
    speech: true
  };

  const STORAGE_KEY = "websiteAccessibilitySettings";

  const html = document.documentElement;

  const toggle = document.getElementById("a11y-toggle");
  const panel = document.getElementById("a11y-panel");
  const close = document.getElementById("a11y-close");

  if (!toggle || !panel) {
    return;
  }

  const settings = {
    textSize: 0,
    contrast: false,
    grayscale: false,
    links: false,
    focus: false,
    animations: false,
    cursor: false,
    dyslexia: false
  };

  /* -------------------------------------------------------
     Automatically hide disabled functions
     ------------------------------------------------------- */

  function configureOptions() {
    document
      .querySelectorAll("[data-a11y-option]")
      .forEach(function (button) {

        const option = button.dataset.a11yOption;

        if (A11Y_OPTIONS[option] === false) {
          button.hidden = true;
        } else {
          button.hidden = false;
        }

      });
  }

  /* -------------------------------------------------------
     Load saved settings
     ------------------------------------------------------- */

  function loadSettings() {
    try {
      const saved = JSON.parse(
        localStorage.getItem(STORAGE_KEY)
      );

      if (saved) {
        Object.assign(settings, saved);
      }
    } catch (error) {
      console.warn("Could not load accessibility settings.");
    }

    applySettings();
  }

  /* -------------------------------------------------------
     Save settings
     ------------------------------------------------------- */

  function saveSettings() {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(settings)
      );
    } catch (error) {
      console.warn("Could not save accessibility settings.");
    }
  }

  /* -------------------------------------------------------
     Apply settings
     ------------------------------------------------------- */

  var contrastStyleTag = null;

  function applyHighContrast(active) {
    if (active) {
      if (!contrastStyleTag) {
        contrastStyleTag = document.createElement("style");
        contrastStyleTag.id = "a11y-high-contrast-style";
        document.head.appendChild(contrastStyleTag);
      }
      contrastStyleTag.textContent = [
        "html.a11y-high-contrast body, html.a11y-high-contrast body *:not(img):not(video):not(svg):not(iframe) {",
        "  background-color: #000000 !important;",
        "  color: #ffffff !important;",
        "  border-color: #ffffff !important;",
        "}",
        "html.a11y-high-contrast a, html.a11y-high-contrast a * { color: #ffff00 !important; }",
        "html.a11y-high-contrast img, html.a11y-high-contrast video, html.a11y-high-contrast svg { filter: brightness(0.8) contrast(1.2); }"
      ].join("\n");

      document.querySelectorAll("[style]").forEach(function (el) {
        if (!el.closest(".a11y-widget")) {
          el.dataset.a11yOrigStyle = el.getAttribute("style");
          el.style.backgroundColor = "#000000";
          el.style.color = "#ffffff";
        }
      });
    } else {
      if (contrastStyleTag) {
        contrastStyleTag.textContent = "";
      }
      document.querySelectorAll("[data-a11y-orig-style]").forEach(function (el) {
        el.setAttribute("style", el.dataset.a11yOrigStyle);
        delete el.dataset.a11yOrigStyle;
      });
    }
  }

  function applySettings() {

    html.classList.remove(
      "a11y-text-large",
      "a11y-text-xlarge"
    );

    if (settings.textSize === 1) {
      html.classList.add("a11y-text-large");
    }

    if (settings.textSize === 2) {
      html.classList.add("a11y-text-xlarge");
    }

    html.classList.toggle(
      "a11y-high-contrast",
      settings.contrast
    );

    applyHighContrast(settings.contrast);

    html.classList.toggle(
      "a11y-grayscale",
      settings.grayscale
    );

    html.classList.toggle(
      "a11y-highlight-links",
      settings.links
    );

    html.classList.toggle(
      "a11y-strong-focus",
      settings.focus
    );

    html.classList.toggle(
      "a11y-reduce-motion",
      settings.animations
    );

    html.classList.toggle(
      "a11y-large-cursor",
      settings.cursor
    );

    html.classList.toggle(
      "a11y-readable-font",
      settings.dyslexia
    );

    updateButtons();
  }

  /* -------------------------------------------------------
     Update active button states
     ------------------------------------------------------- */

  function updateButtons() {

    const actions = document.querySelectorAll(
      "[data-a11y-action]"
    );

    actions.forEach(function (button) {

      const action = button.dataset.a11yAction;

      let active = false;

      switch (action) {

        case "contrast":
          active = settings.contrast;
          break;

        case "grayscale":
          active = settings.grayscale;
          break;

        case "links":
          active = settings.links;
          break;

        case "focus":
          active = settings.focus;
          break;

        case "animations":
          active = settings.animations;
          break;

        case "cursor":
          active = settings.cursor;
          break;

        case "dyslexia":
          active = settings.dyslexia;
          break;
      }

      button.classList.toggle(
        "is-active",
        active
      );

      button.setAttribute(
        "aria-pressed",
        active ? "true" : "false"
      );
    });
  }

  /* -------------------------------------------------------
     Toggle panel
     ------------------------------------------------------- */

  function openPanel() {
    panel.hidden = false;
    toggle.setAttribute("aria-expanded", "true");

    close.focus();
  }

  function closePanel() {
    panel.hidden = true;
    toggle.setAttribute("aria-expanded", "false");

    toggle.focus();
  }

  toggle.addEventListener("click", function () {

    if (panel.hidden) {
      openPanel();
    } else {
      closePanel();
    }

  });

  close.addEventListener("click", closePanel);

  /* -------------------------------------------------------
     Accessibility actions
     ------------------------------------------------------- */

  document
    .querySelectorAll("[data-a11y-action]")
    .forEach(function (button) {

      button.addEventListener("click", function () {

        const action = button.dataset.a11yAction;

        switch (action) {

          case "increase-text":

            settings.textSize = Math.min(
              settings.textSize + 1,
              2
            );

            break;

          case "decrease-text":

            settings.textSize = Math.max(
              settings.textSize - 1,
              0
            );

            break;

          case "reset-text":

            settings.textSize = 0;

            break;

          case "contrast":

            settings.contrast =
              !settings.contrast;

            break;

          case "grayscale":

            settings.grayscale =
              !settings.grayscale;

            break;

          case "links":

            settings.links =
              !settings.links;

            break;

          case "focus":

            settings.focus =
              !settings.focus;

            break;

          case "animations":

            settings.animations =
              !settings.animations;

            break;

          case "cursor":

            settings.cursor =
              !settings.cursor;

            break;

          case "dyslexia":

            settings.dyslexia =
              !settings.dyslexia;

            break;

          case "speech":

            readPage();

            return;

          case "reset":

            resetSettings();

            return;
        }

        saveSettings();
        applySettings();

      });

    });

  /* -------------------------------------------------------
     Reset everything
     ------------------------------------------------------- */

  function resetSettings() {

    settings.textSize = 0;
    settings.contrast = false;
    settings.grayscale = false;
    settings.links = false;
    settings.focus = false;
    settings.animations = false;
    settings.cursor = false;
    settings.dyslexia = false;

    saveSettings();
    applySettings();

    if ("speechSynthesis" in window) {
      window.speechSynthesis.cancel();
    }
  }

  /* -------------------------------------------------------
     Text to speech
     ------------------------------------------------------- */

  function readPage() {

    if (!("speechSynthesis" in window)) {
      alert(
        "Text-to-speech is not supported by this browser."
      );

      return;
    }

    window.speechSynthesis.cancel();

    const content = document.querySelector(
      "main"
    ) || document.querySelector(
      "[role='main']"
    ) || document.body;

    const text = content.innerText
      .replace(/\s+/g, " ")
      .trim();

    if (!text) {
      return;
    }

    const utterance =
      new SpeechSynthesisUtterance(text);

    utterance.rate = 0.9;
    utterance.pitch = 1;

    window.speechSynthesis.speak(
      utterance
    );
  }

  /* -------------------------------------------------------
     Keyboard support
     ------------------------------------------------------- */

  document.addEventListener("keydown", function (event) {

    if (event.key === "Escape" && !panel.hidden) {
      closePanel();
    }

  });

  /* -------------------------------------------------------
     Close when clicking outside
     ------------------------------------------------------- */

  document.addEventListener("click", function (event) {

    if (
      !panel.hidden &&
      !event.target.closest(".a11y-widget")
    ) {
      closePanel();
    }

  });

  /* -------------------------------------------------------
     Initialise
     ------------------------------------------------------- */

  configureOptions();
  loadSettings();

})();